<template>
  <div>
    <p>Thank you, your cancellation has been confirmed.</p>

    <BookingDetailsPanel ref="BookingDetails" printTitle="Cancellation Confirmation">
    </BookingDetailsPanel>
    <div class="text-center btn-container mt-5">
      <v-layout row wrap>
        <v-flex class="pa-1">
          <v-btn sm4 class="ma-2" color="primary" @click="print()"
            ><v-icon>mdi-printer</v-icon>
            PRINT
          </v-btn>
        </v-flex>
        <v-flex sm4 class="pa-1">
          <v-btn
            class="ma-2"
            color="primary"
            @click="rescheduleAppointmentClick()"
            ><v-icon>mdi-calendar-month</v-icon>
            RESCHEDULE APPOINTMENT
          </v-btn>
        </v-flex>
        <v-flex sm4 class="pa-1">
          <v-btn class="ma-2" color="primary" @click="exitClick()"
            ><v-icon>mdi-exit-run</v-icon>EXIT
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import BookingDetailsPanel from '@/components/BookingDetailsPanel.vue';
import { mapActions } from 'vuex';
import SessionState from '../models/SessionState';

export default {
  components: {
    BookingDetailsPanel,
  },
  methods: {
    ...mapActions(['existingAppointment', 'isNewServiceType']),
    ...mapActions({ isLogInAction: 'isLogIn' }),
    ...mapActions('bookingDetails', {
      newAppointmentSelectedAction: 'newAppointmentSelected',
    }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    rescheduleAppointmentClick() {
      this.existingAppointment({ value: false });
      this.isNewServiceType({ value: false });
      this.newAppointmentSelectedAction({ value: false });
      this.$emit('navigateTo', 'CustomerDetailsPage');
    },
    exitClick() {
      // this.existingAppointment({ value: false });
      this.isLogInAction({ value: false });
      SessionState.ClearSession();
      this.$emit('navigateTo', 'LoginPage');
    },
    print() {
      console.log('Inside print of CancelConfirmationPage');
      this.$refs.BookingDetails.Printer();
    },
  },
};
</script>

<style>
</style>
